import React, { Component, Fragment } from "react";
import { cross } from "react-icons-kit/icomoon/cross";
import SvgIcon from "react-icons-kit";
import { themeService } from "../../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../../../Reports/sims/style";
class ExpandableTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      rowsPerPage: 10,
    };
  }

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };

  render() {
    const { formData, testData, updateInputValues, addRow, deleteRow } = this.props;
    const { currentPage, rowsPerPage } = this.state;

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = testData.slice(indexOfFirstRow, indexOfLastRow);

    return (
      <Fragment>
        <div
          className="mainContent table-report last-page-break-print"
          style={{ ...themeService(switchReportStyle.mainStyle), overflow: "scroll" }}
        >
          <table className="table-bordered" style={{ width: "auto", border: "none" }}>
            <thead>{getTableHeaderOfOEM(formData)}</thead>
            <tbody>
              {currentRows.map((tr, i) => (
                <tr key={i}>
                  <td colSpan={2}>
                    <input
                      style={{ width: "-webkit-fill-available" }}
                      value={tr.checkItemName}
                      onChange={(e) => updateInputValues(e.target.value, "checkItemName", indexOfFirstRow + i)}
                      placeholder="Enter Test Name"
                    />
                  </td>
                  <td colSpan={2}>
                    <input
                      style={{ width: "-webkit-fill-available" }}
                      value={tr.freq}
                      onChange={(e) => updateInputValues(e.target.value, "freq", indexOfFirstRow + i)}
                    />
                  </td>
                  {getSingleRowofOEM(tr, formData)}{" "}
                  <SvgIcon
                    onClick={() => {
                      console.log("clicked");
                      deleteRow(i);
                    }}
                    size={20}
                    icon={cross}
                    style={{ margin: "8px 0 0 5px", verticalAlign: "middle", height: "100%", color: "red", cursor: "pointer" }}
                  />
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={addRow}>Add Row</button>

          {/* Simple Pagination Controls */}
          <div style={{ marginTop: "10px" }}>
            <button onClick={() => this.handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
              Previous
            </button>
            <span style={{ margin: "0 10px" }}>Page {currentPage}</span>
            <button onClick={() => this.handlePageChange(currentPage + 1)} disabled={indexOfLastRow >= testData.length}>
              Next
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default React.memo(ExpandableTable);

// Helper function to get table header
const getTableHeaderOfOEM = (data) => {
  const { startEngHour, endEngHour, gap } = data;

  const tHeader = [
    <th colSpan={2} style={{ border: "1px solid black" }}>
      Test Name
    </th>,
    <th colSpan={2} style={{ border: "1px solid black" }}>
      Every
    </th>,
  ];
  for (let i = gap; i <= endEngHour; i += gap) {
    tHeader.push(
      <th colSpan={1} key={i} style={{ border: "1px solid black", paddingInline: "10px" }}>
        {i}
      </th>,
    );
  }
  return <tr>{tHeader}</tr>;
};

// Helper function to get a single row for OEM
const getSingleRowofOEM = (obj, data) => {
  const { startEngHour, endEngHour, gap } = data;
  const { checkItemName, freq, startHour } = obj;
  const tRow = [];
  for (let i = gap, k = 0; i <= endEngHour; i += gap, k += 1) {
    if (k >= startHour) {
      if ((k + 1) % freq === 0) {
        tRow.push(<td key={i}>X</td>);
      } else {
        tRow.push(<td key={i}></td>);
      }
    } else {
      tRow.push(<td key={i}></td>);
    }
  }
  return tRow;
};



// WEBPACK FOOTER //
// ./src/components/AssetView/OEM/CreateNewOEM/inputs/ExpandableTable.jsx